import { z } from "zod/v4"

export const CreatedAt = z.number().describe("ドキュメントの作成日時 (UNIX Timestamp mills) です。")
export const UpdatedAt = z.number().describe("ドキュメントの更新日時 (UNIX Timestamp mills) です。")
export const FirestoreTimestampSchema =
  z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
  }).describe(
    "firestore の Timestamp 型を示す型です。クライアントからの直接の書き込みや、TTL設定のために利用されます。" +
    "serverTimestamp()を指定した場合は、一時的に null で情報がセットされるので、注意してください。"
  )

export type FirestoreTimestampSchema = z.infer<typeof FirestoreTimestampSchema>

export const MigrationDocumentBody =
  z.object({
    git_hash: z.string().optional().describe("この migration が適用された時の git のハッシュ"),
    created_at: z.number(),
    updated_at: z.number(),
  })
